import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import {
  Announcement,
  useAnnouncements,
} from "../../../../../../../contexts/announcement-context/AnnouncementContext";
import "./styles.scss";
// @ts-ignore
import renderHTML from "react-render-html";
import moment from "moment";
import { useAppContext } from "../../../../../../../contexts/app-context/AppContext";
import UserNotification from "../../../../../../../shared/components/Notification/UserNotification";
import ConfirmationModal from "../../../../../../../shared/components/confirmationModal/ConfirmationModal";

interface IProps {
  i: number;
  announcement: Announcement;
}

const AnnouncementCardAdmin = (props: IProps) => {
  const { push } = useHistory();
  const app = useAppContext();
  const [loading, setLoading] = useState(false);
  const [showDeleteConformation, setShowDeleteConformation] = useState(false);
  const { deleteAnnouncement } = useAnnouncements();

  return (
    <div
      className="annoucement-card"
      style={props.i === 0 ? { borderTop: "#ededed solid 1px" } : {}}
    >
      <div className="ann-m-content">
        <div className="ann-top">
          <div className="ann-title">
            <label>{props.announcement.title}</label>
          </div>
          <div>
            <StatusLabel
              priority={props.announcement.isActive ? "active" : "inactive"}
            />
          </div>
        </div>
        <div className="ann-flex-container">
          <div className="ann-right multi-line-truncate pr-2">
            {renderHTML(
              props.announcement.description
                .replace(/<[^>]+>/g, "")
                .replace(/&nbsp;/g, "")
            )}
          </div>
          <div className="ann-left">
            <div>
              <label className="font-weight-bold">Announced On : </label>{" "}
              {moment(new Date(props.announcement.date?.seconds * 1000)).format(
                "MM/DD/YYYY"
              )}
              <span className="ml-3">
                {moment(
                  new Date(props.announcement.date?.seconds * 1000)
                ).format("h:mm A")}
              </span>
            </div>
            <div>
              <label className="font-weight-bold">Announced By : </label>{" "}
              {props.announcement.createdByName}
            </div>
            <div className="d-flex">
              <label className="font-weight-bold mr-2">Attachments : </label>{" "}
              <span className="atach-count">
                {props.announcement.fileURLs?.length}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="m-action text-right mt-3">
        <button
          className="app-button mr-2"
          onClick={() => {
            setShowDeleteConformation(true);
          }}
          style={{ backgroundColor: "#e74c3c" }}
        >
          Delete
        </button>
        {/* )} */}
        <button
          className="app-button"
          onClick={() => {
            app.pushBackURL("/dashboard/announcements");
            push(
              `/dashboard/announcements/announcement/${props.announcement.id}`
            );
          }}
        >
          View
        </button>
      </div>
      <ConfirmationModal
        loading={loading}
        children={{
          headerText: "Confirm Delete",
          bodyText: <>Are you sure you want to delete the notice?</>,
          cancelButtonText: "Cancel",
          confirmButtonText: "Delete",
          confirmButtonColor: loading ? "grayStatic" : "blue",
        }}
        show={showDeleteConformation}
        onCancel={() => {
          if (!loading) setShowDeleteConformation(false);
        }}
        onConfirm={() => {
          if (!loading) {
            setLoading(true);
            deleteAnnouncement(props.announcement.id, (status) => {
              if (status) {
                UserNotification({
                  isSuccess: true,
                  message: "Notice Successfully Deleted!",
                });
              } else {
                UserNotification({
                  isSuccess: false,
                  message: "Notice Failed to Delete!",
                });
              }

              setLoading(false);
            });
          }
        }}
      />
    </div>
  );
};

export default AnnouncementCardAdmin;

export const StatusLabel = (props: {
  priority: "hight" | "medium" | "low" | "active" | "inactive";
}) => {
  return (
    <label className={`priority-label pr-${props.priority}`}>
      {props.priority.charAt(0).toUpperCase() + props.priority.slice(1)}
    </label>
  );
};
